import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-input-header',
  templateUrl: './input-header.component.html',
  styleUrls: ['./input-header.component.scss']
})
export class InputHeaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
